import { useState, useCallback, useRef } from "react";
import { GoogleMap, useLoadScript, Polygon } from "@react-google-maps/api";
import { Button, Toast } from "react-bootstrap";
import { Trash, Save } from "react-bootstrap-icons";

const containerStyle = { width: "100%", height: "500px" };

const GoogleMapPolygon = ({ onPolygonComplete, defaultPolygon = [] }) => {
  const { isLoaded } = useLoadScript({ googleMapsApiKey: "AIzaSyDryqrcseurbwqIRH0xTO7FTASbFKXPkKM" });
  const [polygonPath, setPolygonPath] = useState(defaultPolygon);
  const [showToast, setShowToast] = useState(false); // para confirmación
  const polygonRef = useRef(null);
  const mapRef = useRef(null);
  const center = defaultPolygon[0] ?? { lat: 4.809877249840359, lng: -75.6906152206606 };

  const handleMapClick = useCallback(
    (e) => {
      // Evitar agregar puntos si el polígono ya está finalizado
      if (polygonPath.length > 0 && polygonRef.current && !polygonRef.current.getEditable()) return;

      // Construimos el nuevo path
      const newPath = [
        ...polygonPath,
        { lat: e.latLng.lat(), lng: e.latLng.lng() }
      ];

      // Actualizamos el estado
      setPolygonPath(newPath);

      // Llamamos al callback pasando el nuevo path
      if (onPolygonComplete) {
        onPolygonComplete(newPath);
      }
    },
    [polygonPath, onPolygonComplete]
  );

  const handleEdit = () => {
    if (!polygonRef.current) return;
    const newPath = polygonRef.current.getPath().getArray().map((latLng) => ({
      lat: latLng.lat(),
      lng: latLng.lng()
    }));
    setPolygonPath(newPath);
    if (onPolygonComplete) onPolygonComplete(newPath);
  };

  const deletePolygon = () => {
    setPolygonPath([]);
    polygonRef.current = null;
  };

  if (!isLoaded) return <div>Cargando mapa...</div>;

  return (
    <div style={{ position: "relative" }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={18}
        onClick={handleMapClick}
        onLoad={(map) => (mapRef.current = map)}
      >
        {polygonPath.length > 0 && (
          <Polygon
            paths={polygonPath}
            editable
            draggable
            options={{
              fillColor: "lightgreen",
              fillOpacity: 0.4,
              strokeColor: "green",
              strokeWeight: 2
            }}
            onMouseUp={handleEdit}
            onDragEnd={handleEdit}
            onLoad={(polygon) => (polygonRef.current = polygon)}
          />
        )}
        {/* Botones flotantes a la derecha */}
        <div
          style={{
            position: "absolute",
            top: 60,
            right: 10, // <- cambiamos de centro a derecha
            display: "flex",
            flexDirection: "column", // apilados verticalmente
            gap: "10px",
            zIndex: 10
          }}
        >
          <Button variant="danger"  onClick={deletePolygon}>
            <Trash size={18} />
          </Button>
        </div>
      </GoogleMap>
      
      {/* Toast de confirmación */}
      <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={2000}
        autohide
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          zIndex: 20,
          minWidth: "200px",
          display: "flex",
          alignItems: "center",
          gap: "10px"
        }}
      >
        <Toast.Body>
          <Save size={20} style={{ marginRight: "5px" }} />
          Polígono guardado correctamente
        </Toast.Body>
      </Toast>
    </div>
  );
};

export default GoogleMapPolygon;
